(ns common.schema.entities.fee.permissions
  (:require
   [common.features.plan :as plan]
   [common.schema.entities.permissions :as entity-permissions]))

(defn read-permissions?
  [{:keys [account-current-permissions tenant role tenant-plan]}]
  (and (plan/available :feature/fee-tracking tenant role tenant-plan)
       (contains? (:account-modules account-current-permissions)
                  :module/fee-tracking)))

;; TODO: we need explicit delete permissions to be configured for non activity entity types
(defn disable-permissions?
  [ctx]
  (entity-permissions/disable-when-no-write-permission ctx))
